import { splashDeckHighlights, splashDeckVideo } from "@/mocks/homeData";
import { WHATSAPP_LINK } from "@/pages/home/constants";

export default function SplashDeck() {
  return (
    <section id="splash-deck" className="relative py-7 md:py-12 bg-background-50 scroll-mt-16 overflow-hidden">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-[1500px] mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-12 items-center">
            <div className="reveal order-1">
              <div className="relative w-full max-w-xs sm:max-w-sm mx-auto">
                <div className="relative w-full aspect-video rounded-2xl overflow-hidden border border-secondary-200 bg-foreground-950">
                  <video
                    className="w-full h-full object-cover"
                    src={splashDeckVideo}
                    autoPlay
                    muted
                    loop
                    playsInline
                    preload="metadata"
                    aria-label="Splash Deck Ecotur — piscina flutuante no Lago de Furnas"
                  />
                </div>

                <div className="absolute -top-3 -left-3 hidden sm:flex items-center gap-2 bg-accent-500 text-primary-950 px-3 py-1.5 rounded-full">
                  <i className="ri-sparkling-2-line text-sm" />
                  <span className="text-[11px] font-bold uppercase tracking-wide">Exclusivo Ecotur</span>
                </div>
              </div>
            </div>

            <div className="reveal reveal-delay-2 order-2">
              <span
                translate="no"
                className="notranslate inline-block text-[11px] md:text-xs font-semibold uppercase tracking-[0.2em] text-primary-700 mb-3"
              >
                Splash Deck Ecotur
              </span>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight mb-4">
                <span translate="no" className="notranslate">
                  Splash Deck
                </span>
                : sua piscina flutuante no Lago de Furnas
              </h2>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                A{" "}
                <span translate="no" className="notranslate">
                  Splash Deck Ecotur
                </span>{" "}
                é uma boia flutuante exclusiva, criada para deixar o seu passeio de lancha ainda mais
                divertido e sofisticado. Seu passeio exclusivo acaba de ganhar um novo nível.
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-5">
                Desça da lancha, mergulhe nas águas do Lago de Furnas e aproveite a{" "}
                <span translate="no" className="notranslate">
                  Splash Deck Ecotur
                </span>
                . Uma experiência exclusiva para quem quer curtir Capitólio de um jeito diferente —
                perfeita para relaxar, se divertir, fazer fotos incríveis e transformar o passeio em uma
                lembrança inesquecível.
              </p>

              <div className="grid grid-cols-3 gap-2 sm:gap-3 mb-5">
                {splashDeckHighlights.map((item) => (
                  <div
                    key={item.id}
                    className="flex flex-col items-center text-center gap-2 rounded-xl border border-secondary-200 bg-background-100 p-3 md:p-4"
                  >
                    <span className="w-9 h-9 md:w-11 md:h-11 rounded-full bg-primary-500/12 flex items-center justify-center flex-shrink-0">
                      <i className={`${item.icon} text-primary-600 text-lg md:text-xl`} />
                    </span>
                    <div>
                      <h3 className="text-xs md:text-sm font-heading font-bold text-foreground-950 mb-0.5 leading-tight">
                        {item.title}
                      </h3>
                      <p className="text-[10px] md:text-xs text-foreground-600 leading-snug">
                        {item.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              <a
                href={WHATSAPP_LINK}
                data-whatsapp-cta
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-md text-sm font-bold bg-accent-500 text-primary-950 hover:bg-accent-400 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line text-lg" />
                Quero meu passeio exclusivo
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}